<div
  class="booking-entry-widget-root flex flex--column relative white-bg surface-primary rounded-large"
  [class.pr-medium]="!isNewBrand()"
  [class.ps-medium]="isNewBrand()"
  [class.compact-widget]="compactMode()"
  #widgetRoot
  [@smoothGrow]="{ value: showCompact$ | async, params: { startHeight: (rootContainerStartHeight$ | async) } }"
  (click)="startHotjarCapture()"
  data-testid="booking-widget-entry"
>
  @if (compactMode()) {
    <div class="frost booking-entry-widget-frost" aria-hidden="true"></div>
  }

  <div class="booking-entry-widget-content relative flex flex--column">
    @if (headingLevel() === 1) {
      <h1
        [ngStyle]="h1Style$ | async"
        class="nordic-blue-900-text text-icon-primary font-heading-2 font-headline-medium"
        data-testid="booking-widget-title"
      >
        {{ titleText$ | async }}
      </h1>
    }

    @if (headingLevel() === 2) {
      <h2
        class="nordic-blue-900-text text-icon-primary font-heading-3 font-headline-small"
        data-testid="booking-widget-title"
      >
        {{ 'bookingSearch.title' | finLocalization }}
      </h2>
    }

    @if (isInsideReactNativeWebView) {
      <div class="ps-medium-t">
        @switch (activeTab()) {
          @case (WidgetTab.FLIGHT) {
            <ng-container [ngTemplateOutlet]="flightSearch" />
          }
          @case (WidgetTab.AWARD) {
            <ng-container [ngTemplateOutlet]="awardSearch" />
          }
          @case (WidgetTab.AM) {
            <ng-container [ngTemplateOutlet]="amSearch" />
          }
          @case (WidgetTab.HOTELS) {
            <ng-container [ngTemplateOutlet]="hotelSearch" />
          }
          @case (WidgetTab.CARTRAWLER) {
            <ng-container [ngTemplateOutlet]="carSearch" />
          }
        }
      </div>
    } @else if (activeTab(); as activeTab) {
      <fcom-tabs
        [class.ps-medium-t]="!isNewBrand()"
        [theme]="TabTheme.DEFAULT"
        [bottomBorder]="false"
        [whiteSpaceNowrap]="true"
        (clickedTab)="setActiveTab($event)"
        [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
        [nextButtonAriaLabel]="'carousel.next' | finLocalization"
        data-testid="booking-widget-tabs"
      >
        <!-- flight -->
        <fcom-tab
          [title]="'bookingWidgetTabs.flight' | finLocalization"
          [attr.data-testid]="'booking-widget-tab-' + WidgetTab.FLIGHT"
          [data]="WidgetTab.FLIGHT"
          [active]="activeTab === WidgetTab.FLIGHT"
        >
          @if (activeTab === WidgetTab.FLIGHT) {
            <ng-container [ngTemplateOutlet]="flightSearch" />
          }
        </fcom-tab>

        <!-- award -->
        @if (enableAward()) {
          <fcom-tab
            [title]="'bookingWidgetTabs.award' | finLocalization"
            [attr.data-testid]="'booking-widget-tab-' + WidgetTab.AWARD"
            [data]="WidgetTab.AWARD"
            [active]="activeTab === WidgetTab.AWARD"
          >
            @if (activeTab === WidgetTab.AWARD) {
              <ng-container [ngTemplateOutlet]="awardSearch" />
            }
          </fcom-tab>
        }

        <!-- flightPlusHotel -->
        @if (showHotelsTab && isAMLocale) {
          <fcom-tab
            [title]="'bookingWidgetTabs.flightAndHotel' | finLocalization"
            [attr.data-testid]="'booking-widget-tab-' + WidgetTab.AM"
            [data]="WidgetTab.AM"
            [active]="activeTab === WidgetTab.AM"
          >
            @if (activeTab === WidgetTab.AM) {
              <ng-container [ngTemplateOutlet]="amSearch" />
            }
          </fcom-tab>
        }

        <!-- hotels -->
        @if (showHotelsTab && !isAMLocale) {
          <fcom-tab
            [title]="'bookingWidgetTabs.hotels.tabTitle' | finLocalization"
            [attr.data-testid]="'booking-widget-tab-' + WidgetTab.HOTELS"
            [data]="WidgetTab.HOTELS"
            [active]="activeTab === WidgetTab.HOTELS"
          >
            <ng-container [ngTemplateOutlet]="hotelSearch" />
          </fcom-tab>
        }

        <!-- carTrawler -->
        @if (showCarTrawlerTab) {
          <fcom-tab
            [title]="'bookingWidgetTabs.carTrawler.tabTitle' | finLocalization"
            [attr.data-testid]="'booking-widget-tab-' + WidgetTab.CARTRAWLER"
            [data]="WidgetTab.CARTRAWLER"
            [active]="activeTab === WidgetTab.CARTRAWLER"
          >
            <ng-container [ngTemplateOutlet]="carSearch" />
          </fcom-tab>
        }
      </fcom-tabs>
    }
  </div>
</div>

<ng-template #flightSearch>
  <fin-booking-widget-common
    [defaultLocations]="defaultLocations()"
    [layout]="layout()"
    data-testid="booking-widget-flight"
    [identifier]="calendarIdentifier"
    [isFrontPage]="isFrontPage()"
    [enablePromoCode]="enablePromoCode()"
    [compactMode]="compactMode()"
  />
</ng-template>

<ng-template #awardSearch>
  @switch (loginStatus()) {
    @case (LoginStatus.NOT_LOGGED_IN) {
      <fin-login-card [benefitMode]="'text'" [benefitText]="'award.login.description'" [title]="'award.login.title'" />
    }
    @case (LoginStatus.PENDING) {
      <fcom-loader [loaderType]="LoaderTheme.EMBEDDED" [title]="'loader.title'" />
    }
    @case (LoginStatus.LOGGED_IN) {
      <fin-booking-widget-common
        [defaultLocations]="defaultLocations()"
        [layout]="layout()"
        data-testid="booking-widget-award"
        [identifier]="calendarIdentifier"
        [compactMode]="compactMode()"
      />
    }
  }
</ng-template>

<ng-template #amSearch>
  <fin-am-booking-widget (setLocations)="onAmLocationChanged()" data-testid="booking-widget-am" />
</ng-template>

<ng-template #hotelSearch>
  @if (showHotelSearch) {
    <fin-hotel-search-widget />
  } @else {
    <fin-third-party-booking-widget [type]="ThirdPartyAncillariesProvider.EXPEDIA_HOTEL" />
  }
</ng-template>

<ng-template #carSearch>
  @if (showCarRentalSearch) {
    <fin-car-rental-search-widget />
  } @else {
    <fin-third-party-booking-widget [type]="ThirdPartyAncillariesProvider.CAR_TRAWLER_RENTAL" />
  }
</ng-template>
